export default "__VITE_ASSET__V5Gt8rE7__"